import { useMemo } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { EMPTY_LIST_MEMBERS, orderedListsForBoard } from "../../lib/listSharing";
import type { List } from "../../types";
import { useListMembers } from "./useListMembers";
import { useSharedListIds } from "./useSharedListIds";

/**
 * Lists this person may act on: ones they own, plus ones they have
 * accepted. An unanswered Invitation is left out. Also returns the
 * shared-mark set (any membership row), so a screen does not have to
 * re-derive either fact for itself.
 */
export function useOrderedLists(lists: List[]) {
  const { user } = useAuth();
  const { data: memberRows } = useListMembers();
  const members = memberRows ?? EMPTY_LIST_MEMBERS;
  const { data: sharedListIds } = useSharedListIds();
  const visibleLists = useMemo(
    () => (user ? orderedListsForBoard(lists, members, user.id) : []),
    [lists, members, user],
  );
  return { lists: visibleLists, sharedListIds };
}
